import { cn } from "@/lib/utils";

/**
 * Content placeholder shown while data loads (the skeleton-first app-shell
 * model, ARCHITECTURE.md §2). Compose several to mirror a surface's layout.
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      aria-hidden="true"
      {...props}
    />
  );
}
